<template>
  <div>
    <svg
      class="numeric-svg"
      viewBox="0 0 50 100"
      preserveAspectRatio="xMidYMin meet"
    >
      <rect
        class="numeric-background"
        width="40"
        height="20"
        x="5"
        :y="yPosBackground"
        :style="backgroundstyle"
      ></rect>
      <text
        class="numeric-text"
        width="40"
        height="10"
        x="25"
        :y="yPosText"
        text-anchor="middle"
        font-size="18"
      >
        {{ valueText }}
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'PercentNumeric',
  props: {
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  },
  computed: {
    yPosBackground() {
      if (Number.isNaN(this.value)) return 40
      else return 80 - ((this.value - this.min) / (this.max - this.min)) * 80
    },
    valueText() {
      if (Number.isNaN(this.value)) return '-'
      else return this.value + '%'
    },
    yPosText() {
      return this.yPosBackground + 18
    },
    backgroundstyle() {
      return { fill: this.color }
    }
  }
}
</script>

<style scoped>
.numeric-svg {
  width: 100%;
  height: 100%;
}
.numeric-text {
  fill: white;
}
</style>
